import { WifiOff, Wifi } from 'lucide-react'
import { useNetworkStatus } from '@/hooks/useNetworkStatus'

export function NetworkBanner() {
  const status = useNetworkStatus()

  if (status === 'online') return null

  return (
    <div className={`
      fixed top-0 inset-x-0 z-50 flex items-center justify-center gap-2 py-2.5 text-sm font-medium
      ${status === 'offline'
        ? 'bg-room-error/90 text-white backdrop-blur-sm'
        : 'bg-room-warning/90 text-white backdrop-blur-sm'}
    `}>
      {status === 'offline' ? (
        <><WifiOff size={14} /> Offline — uploads will resume when reconnected</>
      ) : (
        <><Wifi size={14} /> Slow connection — uploads may take longer</>
      )}
    </div>
  )
}
